import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { trigger, state, style, animate, transition } from '@angular/animations';
import { CommonService } from '../../services/common.service';
import { Router } from '@angular/router';
import { EnvironmentService } from 'src/app/trip-replay/services/img-source.service';
import { DateUtils } from 'src/app/utils/days-utils';
import { ASSETS_PATH_CONST } from '../../../modern-multi-trip-view/constants/image-assets.constants';
import { DataService } from 'src/app/data.service';
import { Subscription } from 'rxjs';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';


@Component({
  selector: 'app-side-bar',
  templateUrl: './side-bar.component.html',
  styleUrls: ['./side-bar.component.scss'],
  animations: [
    trigger('expandedAnimation', [
      state('true', style({ transform: 'rotate(-180deg)', 'transform-origin': '50% 50%' })),
      state('false', style({ transform: 'rotate(0deg)', 'transform-origin': '50% 50%' })),
      transition('false <=> true', animate('0.5s ease-in-out'))
    ]),
    trigger('expandCollapse', [
      state('collapsed', style({
        height: '0px',
        opacity: 0,
        overflow: 'hidden'
      })),
      state('expanded', style({
        height: '*',
        opacity: 1,
        overflow: 'visible'
      })),
      transition('collapsed <=> expanded', [
        animate('500ms ease-in-out')
      ])
    ]),
    trigger('rotateArrow', [
      state('collapsed', style({
        transform: 'rotate(0deg)'
      })),
      state('expanded', style({
        transform: 'rotate(180deg)'
      })),
      transition('collapsed => expanded', [
        animate('0.3s')
      ]),
      transition('expanded => collapsed', [
        animate('0.3s')
      ])
    ])
  ]
})
export class SideBarComponent implements OnInit, OnDestroy {
  ASSETS_PATH_CONST = ASSETS_PATH_CONST;
  imgSrc: string;
  tripDutyToggler: any = 'trip';
  expandedToggler: boolean = true
  response: any;
  loader: any;
  womenTravellingAlone = false;
  nextTrip;
  nextTripInfo = false;
  nextTripData;
  safetyAlert: [];
  ETS_MASTER_PROPERTIES: any = {};
  dataServiceSubscription: Subscription;

  @Input() callFromTrip: boolean = true;
  isAssistantOpen: boolean = false;
  aiBotURLSafe: SafeResourceUrl = "";
  aiBotEnabled: boolean = false;
  hideBot: boolean = false;

  constructor(private commonService: CommonService,
    private router: Router, private envService: EnvironmentService, private dataService: DataService, private sanitizer: DomSanitizer
  ) { }

  ngOnInit(): void {
    this.imgSrc = this.envService.getImgSrc();
    this.loader = this.commonService.loader
    this.response = this.commonService.response
    this.nextTrip = this.response['tripDetails']['nextTripStartTime'];
    this.nextTrip = this.nextTrip ? DateUtils.formatTimeWithZone(this.nextTrip, this.commonService.timeZone, 'DD MMM, HH:mm'): this.nextTrip;
    this.commonService.womenTravellingAlone$.subscribe((res) => {
      this.womenTravellingAlone = res;
    })
    this.commonService.safetyAlert$.subscribe((res) => {
      this.safetyAlert = res;
    })
    console.log("response testing", this.response);

    this.dataServiceSubscription = this.dataService.ETS_PROPERTIES$.subscribe((properties:any)=>{
      this.ETS_MASTER_PROPERTIES = properties;
      if(this.ETS_MASTER_PROPERTIES.AI_BOT_URL){
        this.aiBotURLSafe = this.sanitizer.bypassSecurityTrustResourceUrl(`${this.ETS_MASTER_PROPERTIES.AI_BOT_URL}/atlas-assistant/`);
      }
      this.aiBotEnabled = this.ETS_MASTER_PROPERTIES.ENABLE_ADMIN_AI_BOT && this.ETS_MASTER_PROPERTIES.AI_BOT_URL;

      if(this.aiBotEnabled){
        this.listenToAssistantEvents();
      }
    })
  }

  ngOnDestroy(): void {
    this.dataServiceSubscription.unsubscribe();
  }

  gotoTripReplay() {
    this.commonService.goToTripReplay();
  }



  expandedToggle() {
    this.expandedToggler = !this.expandedToggler
  }
  tripDutyToggle(value: string) {

    if (value == 'trip') {
      this.tripDutyToggler = 'trip'
    }
    else {
      this.tripDutyToggler = 'duty'
    }

  }
  nextTripPopup() {
    this.commonService.nextTripDetails(this.response['tripDetails']['nextTripGuid']).subscribe((res) => {
      this.nextTripInfo = true;
      this.nextTripData = res;

    })
  }

  goToDashboard() {
    this.commonService.getEtsUrl().subscribe((url:string)=>{
      let pathname=url+"master.jsp#transport-dashboard"
      window.open(pathname,'_top');
    })

  }

  openAssistant(){
    if(!this.isAssistantOpen){
      this.isAssistantOpen = true;
      this.hideBot = false;
    }else{
      this.hideBot = !this.hideBot;
    }
    window.postMessage({
      applicationName: 'Trip View',
    }, '*');
  }

  listenToAssistantEvents(){

    window.addEventListener('message', (event) => {
      if (event.data.eventType === 'CLOSE_ASSISTANT') {
        this.isAssistantOpen = false;
      }else if(event.data.eventType === 'MINIMIZE_ASSISTANT'){
        this.hideBot = true;
      }
    });
  }
}
